import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";

export default function CheckBoxList({ options, checked, setChecked }) {
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  return (
    <List sx={{ width: "100%" }}>
      {options.map((option) => {
        const labelId = `checkbox-conditional-label-${option.id}`;
        return (
          <ListItem
            key={option.id}
            role={undefined}
            dense
            button
            onClick={handleToggle(option.id)}
            sx={{ borderRadius: 2 }}
          >
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={checked.indexOf(option.id) !== -1}
                tabIndex={-1}
                disableRipple
                color="primary"
                inputProps={{ "aria-labelledby": labelId }}
              />
            </ListItemIcon>
            <ListItemText id={labelId} primary={`${option.title}`} />
          </ListItem>
        );
      })}
    </List>
  );
}
